import React from 'react';
import ReportSectionPage from '../../../common/components/reports/ReportSectionPage';

const TransactionsReport = () => {
  return <ReportSectionPage scope="super-admin" section="transactions" title="Transactions Report" />;
};

export default TransactionsReport;
